// extracted by mini-css-extract-plugin
export var parcelRow = "_um-0";